interface CarePlusCategoryCardProps {
    category: SidebarTopCategory;
}

const getAssetUrl = (mention: string, extension: string) => {
    const assetBasePath = (window as any).clientConfig?.assetBasePath || "https://images.doktorabc.com/redesign_2025";
    return `${assetBasePath}/menu/${mention}/menu_icon/menu_icon.${extension}`;
};

export default function CarePlusCategoryCard({ category }: CarePlusCategoryCardProps) {

    const mention = category.assetMention || category.mention || "";

    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (category.url) {
            window.location.href = category.url;
        }
    };

    return (
        <a href={category.url} onClick={handleClick} className="care-plus-category-card">
            <span className="care-plus-category-card-label">{category.label}</span>
            <picture className="care-plus-category-card-icon">
                <source srcSet={getAssetUrl(mention, "webp")} type="image/webp" />
                <img
                    src={getAssetUrl(mention, "png")}
                    alt=""
                    onError={(e) => { (e.target as HTMLImageElement).style.display = "none"; }}
                    loading="lazy"
                    decoding="async"
                />
            </picture>
            <span className="care-plus-category-card-arrow" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M8 11.5C7.72386 11.5 7.5 11.7239 7.5 12C7.5 12.2761 7.72386 12.5 8 12.5V12V11.5ZM8 12V12.5L16 12.5V12V11.5L8 11.5V12ZM16.3536 12.3536C16.5488 12.1583 16.5488 11.8417 16.3536 11.6464L13.1716 8.46447C12.9763 8.2692 12.6597 8.2692 12.4645 8.46447C12.2692 8.65973 12.2692 8.97631 12.4645 9.17157L15.2929 12L12.4645 14.8284C12.2692 15.0237 12.2692 15.3403 12.4645 15.5355C12.6597 15.7308 12.9763 15.7308 13.1716 15.5355L16.3536 12.3536Z" fill="#1F2129" />
                </svg>
            </span>
        </a>
    )
}
